// --------------------------------------------------------------
// Created On: 2024-03-28
// Author: Zachary Thomas
//
// Last Modified: 2025-10-29
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";

// This is an input field that accepts phone numbers.
export default function PhoneNumberInput(props: Props): Component {
  // Update the international calling code and the base phone number.
  function handlePhoneNumber(phone: string, meta: Meta): void {
    const callingCode = meta.country.dialCode;
    props.onChangeCallingCode(callingCode);
    if (phone.startsWith(`+${callingCode}`)) {
      const phoneNumberWithoutCallingCode = phone.slice(1 + callingCode.length);
      props.onChangePhoneNumber(phoneNumberWithoutCallingCode);
    }
  }

  return (
    <div>
      <label className={`${props.labelClassName}`}>{props.labelText}</label>
      <PhoneInput
        placeholder="Enter phone number..."
        value={`+${props.callingCode}${props.phoneNumber}`}
        defaultCountry="us"
        disableDialCodeAndPrefix
        disabled={props.disabled}
        inputClassName={props.inputClassName}
        onChange={(phone, meta) => handlePhoneNumber(phone, meta)}
      />
    </div>
  );
}

interface Props {
  labelText: string;
  phoneNumber: string;
  callingCode: string;
  labelClassName?: string;
  inputClassName?: string;
  disabled?: boolean;
  onChangePhoneNumber: (phoneNumber: string) => void;
  onChangeCallingCode: (callingCode: string) => void;
}

interface Meta {
  country: Country;
}

interface Country {
  dialCode: string;
  name: string;
}
